import { render, staticRenderFns } from "./bill.vue?vue&type=template&id=0cfc24e1&"
import script from "./bill.vue?vue&type=script&lang=ts&"
export * from "./bill.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports